export default "__VITE_ASSET__CBUcoxY2__"